// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aminities-container {
  display: flex;
  align-items: center;
  justify-content: space-around;
  align-content: space-around;
  padding-bottom: 30px;
}

element.style {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 30px;
  margin-bottom: 30px;
  border-radius: 8px;
}

.card-section {
  border-radius: 16px;
  background: #313b2f;
  box-shadow: 0px 16px 40px 0px rgba(0, 0, 0, 0.32);
  color: white;
  margin: 7px;
}

.card-section {
  border-radius: 16px;
  background: #313b2f;
  box-shadow: 0px 16px 40px 0px rgba(0, 0, 0, 0.32);
  color: white;
  /* margin: 7px 19px; */
  padding: 32px;
  text-align: left !important;
}

h4.card-title {
  text-align: center;
  color: var(--White, #fff);
  font-family: "Playfair Display" !important
  ;
  font-size: 19px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-transform: uppercase;
  padding-bottom: 20px;
}

.card-aminities {
  display: flex;
  align-content: center;
  align-items: center;
}

.card-aminities {
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: flex-start;
  padding-bottom: 26px;
  width: 11rem;
}

.card-aminities p {
  padding-left: 2rem;
}

.card-section {
  border-radius: 16px;
  background: #313b2f;
  box-shadow: 0px 16px 40px 0px rgba(0, 0, 0, 0.32);
  color: white;
  /* margin: 7px 14px; */
  padding: 33px;
  text-align: left !important;
  height: 538px;
}

.aminities-container {
  display: flex;
  align-items: center;
  justify-content: space-around;
  align-content: space-around;
  padding-bottom: 30px;
  margin-left: -7px;
}

.card-aminities img {
  width: 40px;
  height: 40px;
}

.card-aminities p {
  padding-left: 2rem;
  color: white;
}
.four-box {
  border-radius: 16px;
  background: rgba(49, 59, 47, 0.7) !important;
  box-shadow: 0px 16px 40px 0px rgba(0, 0, 0, 0.32) !important;
}

.five-box {
  border-radius: 16px;
  background: rgba(49, 59, 47, 0.6) !important;
  box-shadow: 0px 16px 40px 0px rgba(0, 0, 0, 0.32) !important;
}

.third-box {
  border-radius: 16px;
  background: rgba(49, 59, 47, 0.8) !important;
  box-shadow: 0px 16px 40px 0px rgba(0, 0, 0, 0.32) !important;
}
.secound-box {
  border-radius: 16px;
  background: rgba(49, 59, 47, 0.9) !important;
  box-shadow: 0px 16px 40px 0px rgba(0, 0, 0, 0.32) !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/AmenitiesComponents.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,iDAAiD;EACjD,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,iDAAiD;EACjD,YAAY;EACZ,sBAAsB;EACtB,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB;EACA;EACA,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,2BAA2B;EAC3B,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,iDAAiD;EACjD,YAAY;EACZ,sBAAsB;EACtB,aAAa;EACb,2BAA2B;EAC3B,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,2BAA2B;EAC3B,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,4CAA4C;EAC5C,4DAA4D;AAC9D;;AAEA;EACE,mBAAmB;EACnB,4CAA4C;EAC5C,4DAA4D;AAC9D;;AAEA;EACE,mBAAmB;EACnB,4CAA4C;EAC5C,4DAA4D;AAC9D;AACA;EACE,mBAAmB;EACnB,4CAA4C;EAC5C,4DAA4D;AAC9D","sourcesContent":[".aminities-container {\n  display: flex;\n  align-items: center;\n  justify-content: space-around;\n  align-content: space-around;\n  padding-bottom: 30px;\n}\n\nelement.style {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 30px;\n  margin-bottom: 30px;\n  border-radius: 8px;\n}\n\n.card-section {\n  border-radius: 16px;\n  background: #313b2f;\n  box-shadow: 0px 16px 40px 0px rgba(0, 0, 0, 0.32);\n  color: white;\n  margin: 7px;\n}\n\n.card-section {\n  border-radius: 16px;\n  background: #313b2f;\n  box-shadow: 0px 16px 40px 0px rgba(0, 0, 0, 0.32);\n  color: white;\n  /* margin: 7px 19px; */\n  padding: 32px;\n  text-align: left !important;\n}\n\nh4.card-title {\n  text-align: center;\n  color: var(--White, #fff);\n  font-family: \"Playfair Display\" !important\n  ;\n  font-size: 19px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  text-transform: uppercase;\n  padding-bottom: 20px;\n}\n\n.card-aminities {\n  display: flex;\n  align-content: center;\n  align-items: center;\n}\n\n.card-aminities {\n  display: flex;\n  align-content: center;\n  align-items: center;\n  justify-content: flex-start;\n  padding-bottom: 26px;\n  width: 11rem;\n}\n\n.card-aminities p {\n  padding-left: 2rem;\n}\n\n.card-section {\n  border-radius: 16px;\n  background: #313b2f;\n  box-shadow: 0px 16px 40px 0px rgba(0, 0, 0, 0.32);\n  color: white;\n  /* margin: 7px 14px; */\n  padding: 33px;\n  text-align: left !important;\n  height: 538px;\n}\n\n.aminities-container {\n  display: flex;\n  align-items: center;\n  justify-content: space-around;\n  align-content: space-around;\n  padding-bottom: 30px;\n  margin-left: -7px;\n}\n\n.card-aminities img {\n  width: 40px;\n  height: 40px;\n}\n\n.card-aminities p {\n  padding-left: 2rem;\n  color: white;\n}\n.four-box {\n  border-radius: 16px;\n  background: rgba(49, 59, 47, 0.7) !important;\n  box-shadow: 0px 16px 40px 0px rgba(0, 0, 0, 0.32) !important;\n}\n\n.five-box {\n  border-radius: 16px;\n  background: rgba(49, 59, 47, 0.6) !important;\n  box-shadow: 0px 16px 40px 0px rgba(0, 0, 0, 0.32) !important;\n}\n\n.third-box {\n  border-radius: 16px;\n  background: rgba(49, 59, 47, 0.8) !important;\n  box-shadow: 0px 16px 40px 0px rgba(0, 0, 0, 0.32) !important;\n}\n.secound-box {\n  border-radius: 16px;\n  background: rgba(49, 59, 47, 0.9) !important;\n  box-shadow: 0px 16px 40px 0px rgba(0, 0, 0, 0.32) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
